module.exports = __webpack_public_path__ + "img/s-about-us-img3.e6de0ecf.jpg";